
function viewProvider(viewName) {
    return ['$transition$', 'AppConfiguration', function ($transition$, AppConfiguration) {
        var view;
        const params = $transition$.params();
        try {
            view = AppConfiguration().getViewByEntityAndType(params.entity, viewName);
        } catch (e) {
            var error404 = new Error('Unknown view or entity name');
            error404.status = 404;
            throw error404;
        }
        return view;
    }];
}


export default function($stateProvider) {
    $stateProvider
        .state('crud', {
            abstract: true,
            url: '/crud/:entity',
            template: '<ui-view></ui-view>',
            resolve: {
                view: viewProvider('ListView'),
                store: ['$transition$', 'DS', function($transition$, DS) {
                    const params = $transition$.params();
                    return DS.definitions[params.entity];
                }]
            }
        })
        .state('crud.list', {
            url: '/list',
            component: 'listView'
        });
}



// WEBPACK FOOTER //
// ./app/components/common/crud/states.js